import { ApolloProvider } from '@apollo/client';
import '@nile/components/src';
import '@nile/itsm';
import { TicketClient, updateClientUri } from '@nile/graphql';
import '@nile/types';
import { AppProvider } from '@superops/ui-design-system';
// import '@shopify/polaris/dist/styles.css';
import '@superops/ui-design-system/build/esm/styles.css';
import '@xyflow/react/dist/style.css';
import './version5style.css';
import './Components/oldtabs.css';
import './Components/oldpopover.css';
import './Components/superbutton.css';
// import './Components/supertabs.css';
import './Components/supercheckbox.css';
import './Components/progressbar.css';
import './Components/superavatar.css';
import hashHistory from '@nile/home/src/hashHistory';
import React, { useEffect, useState } from 'react';
// import ReactDOM from 'react-dom';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { HashRouter as Router } from 'react-router-dom';
import App from './App';
import envConfig from '@nile/home/src/Config/env';
import './index.css';
import './styles/tailwind.css';
import * as serviceWorker from './serviceWorker';
import { AppLoader, DomainErrorPage } from '@nile/components';
import { updateSysClientUri } from '@nile/graphql/src/client';
import {
  initializeCoralogixRUM,
  sendTestLog,
  loggerInfo
} from '@nile/home/src/coralogixRUM';
import MarketplaceApp from './MarketplaceApp';
import { getBaseUrl } from '@nile/components/src/Utils/helpers';

function ProductApp(props) {
  const [enDomain, setEnDomain] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [errorCode, setErrorCode] = useState();
  const [infoData, setInfoData] = useState({});
  var requestOptions = {};
  if (envConfig.mode === 'development') {
    const customerSubDomain = localStorage.getItem('CustomerSubDomain');
    requestOptions = {
      headers: {
        CustomerSubDomain: customerSubDomain,
        CustomOrigin: `${customerSubDomain}.superopsalpha.com`
      }
    };
  }

  useEffect(() => {
    // initializeCoralogixRUM();
    // setTimeout(() => {
    //   sendTestLog();
    // }, 5000);

    const fetchData = async () => {
      try {
        const response = await fetch(envConfig.apiDomainUrl, requestOptions);
        if (!response?.ok) {
          setErrorCode(response.status);
          // if (window.logger) {
          //   logger.info('Domain_info_api_failed_with_error_code', {
          //     errorStatus: response.status,
          //     domain:
          //       localStorage.getItem('CustomerSubDomain') ??
          //       'No domain in storage'
          //   });
          //   logger.flush();
          // }

          loggerInfo('Domain_info_api_failed_with_error_code', {
            errorStatus: response.status,
            domain:
              localStorage.getItem('CustomerSubDomain') ??
              'No domain in storage'
          });

          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        localStorage.setItem('apiDomain', data.serverURL);
        localStorage.setItem('wssSocketUrl', data.websocketURL);
        localStorage.setItem('dcRegion', data.dcRegion);
        localStorage.setItem('apiURL', data.apiURL);
        localStorage.setItem('asyncFileUploadURL', data.asyncFileUploadURL);

        // End of Logger ReInitialize
        setInfoData(data);
        if (data?.productType) {
          localStorage.setItem('productType', data?.productType);
        }
        await updateClientUri(data.serverURL);
        await updateSysClientUri();
        setEnDomain(data.serverURL);

        const regionMap = {
          US: {
            publicKey: 'cxtp_3YW5Amf3oXmdf61PQaqnVQi7TG46VX',
            region: 'US1'
          },
          EU: {
            publicKey: 'cxtp_ZSsC5tOQjEKVw9KLYXhrMVhtPMwThm',
            region: 'EU2'
          }
        };

        const dcRegion = regionMap[data.dcRegion].region || 'US1';
        const coralogixRumPublicKeyProd = regionMap[data.dcRegion]?.publicKey;

        const { coralogixRumPublicKey } = envConfig;

        const rumPublicKey =
          envConfig?.mode === 'production'
            ? coralogixRumPublicKeyProd
            : coralogixRumPublicKey;

        initializeCoralogixRUM(dcRegion, rumPublicKey);
      } catch (error) {
        setApiError(true);
        // if (window.logger) {
        //   logger.info('Domain_info_api_failed', {
        //     error
        //   });
        //   logger.flush();
        // }

        loggerInfo('Domain_info_api_failed', { error });

        console.error('Error fetching Domain info Api data:', error);
      }
    };

    fetchData();
  }, []);

  return enDomain ? (
    <App currentProduct={infoData.productType} />
  ) : (
    <>
      {!apiError ? (
        <div className="vh100 flex center jctr">
          <AppLoader showLetNav />
        </div>
      ) : (
        <DomainErrorPage errorCode={errorCode} />
      )}
    </>
  );
}

// Function to check if locationPathname has "marketplace" as the last path segment
function hasMarketplace(locationPathname) {
  const pathSegments = locationPathname
    .split('/')
    .filter((segment) => segment !== '');
  console.log('marketplace pathnames: ', pathSegments, locationPathname);
  // Check if the first path segment is exactly "marketplace"
  return pathSegments.includes('marketplace');
}

//init call
const initCall = () => {
  // Check if the current URL has an 'email' param
  const params = window.location.href.split('?')[1];
  const allParams = new URLSearchParams(params);
  const email = allParams.get('email');
  const appState = allParams.get('appState');

  let redirectUrl = `${getBaseUrl()}/marketplace/api/authorize/init`;
  if (email) {
    // Re-encode before appending
    redirectUrl += `?email=${encodeURIComponent(email)}`;
  }
  if (appState) {
    // Append appState parameter
    redirectUrl += email ? '&' : '?';
    redirectUrl += `appState=${encodeURIComponent(appState)}`;
  }
  window.location.href = redirectUrl;
};

//domain info call
const domainInfoCall = async () => {
  var requestOptions = {};
  if (envConfig.mode === 'development') {
    const customerSubDomain = localStorage.getItem('CustomerSubDomain');
    requestOptions = {
      headers: {
        CustomerSubDomain: customerSubDomain,
        CustomOrigin: `${customerSubDomain}.superopsalpha.com`
      }
    };
  }
  try {
    const response = await fetch(envConfig.apiDomainUrl, requestOptions);
    const data = await response.json();
    localStorage.setItem('dcRegion', data.dcRegion);
    // console.log('info call for marketplace:', data);
  } catch (error) {
    console.error('Error fetching Domain info Api data:', error);
  }
};

const getCookieValue = (name) => {
  return document.cookie
    .match(RegExp(name + '=.[^;]*'))
    ?.pop()
    ?.replace(`${name}=`, '');
};

const AppDecider = (props) => {
  const location = window.location;
  const marketplaceToken = getCookieValue('so-marketplace-session') || '';
  const productToken = getCookieValue('uitoken') || '';

  useEffect(() => {
    // Remove "marketplace" from URL if it appears exactly before "/#" during product session
    if (marketplaceToken && productToken) {
      const currentUrl = window.location.href;
      const marketplaceBeforeHashRegex = /\/marketplace\/#/;

      if (marketplaceBeforeHashRegex.test(currentUrl)) {
        const cleanedUrl = currentUrl.replace('/marketplace/#', '/#');
        // Use window.location.replace to navigate to the cleaned URL
        window.location.replace(cleanedUrl);
      }
    }
    if (hasMarketplace(location?.pathname) && !marketplaceToken) {
      initCall();
    }
    hasMarketplace(location?.pathname) && domainInfoCall();
  }, []);

  if (hasMarketplace(location?.pathname)) {
    if (!marketplaceToken) {
      return null;
    }
    return <MarketplaceApp />;
  } else {
    return <ProductApp />;
  }
};
export default AppDecider;

const container = document.getElementById('root');

const root = createRoot(container);

root.render(
  <AppProvider i18n={{}}>
    <ApolloProvider client={TicketClient}>
      {/* <Router history={hashHistory}> */}
      <ToastContainer autoClose={1000} className="full-width-toast" />
      <AppDecider />
      <div id="app"> </div>
      {/* </Router> */}
    </ApolloProvider>
  </AppProvider>
);
// ReactDOM.render(
//   <AppProvider i18n={{}}>
//     <ApolloProvider client={TicketClient}>
//       {/* <Router history={hashHistory}> */}
//       <ToastContainer autoClose={1000} className="full-width-toast" />
//       <AppDecider />
//       <div id="app"> </div>
//       {/* </Router> */}
//     </ApolloProvider>
//   </AppProvider>,
//   document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
